// @owners { team: patients }
import { type SurveyResponse } from '@alto/scriptdash/alto/surveys/types/v1/survey_response';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { get } from '~shared/helpers/apiHelper';
import { getErrorMessageFromResponse } from '~shared/helpers/helper';

export const rateShipment = createQueryKeys('rateShipment', {
  pending: {
    queryKey: null,
    queryFn: async (): Promise<SurveyResponse | null> => {
      const response = await get('/survey_responses/check_pending', { survey_type: 'rate_shipment' });
      if (response.error) {
        throw new Error(getErrorMessageFromResponse(response));
      }
      return response?.pending_survey_response ?? null;
    },
    // The global QueryClient defaults to a 20s staleTime; fetchQuery honors it and would return a
    // cached survey response without hitting the network. This survey check fires on every
    // SET_PRESENCE / LOGIN_SUCCEEDED, so pin staleTime: 0 to always fetch fresh — matching the old
    // thunk's behavior, so a survey that becomes available within the 20s window isn't missed.
    staleTime: 0,
  },
});
